import { render, staticRenderFns } from "./add-profile-modal.vue?vue&type=template&id=16043350&scoped=true"
import script from "./add-profile-modal.vue?vue&type=script&lang=js"
export * from "./add-profile-modal.vue?vue&type=script&lang=js"
import style0 from "./add-profile-modal.vue?vue&type=style&index=0&id=16043350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16043350",
  null
  
)

export default component.exports